// const allColors = [
//     [
//         '#10f581',
//         '#032c16'
//     ],
//     [
//         '#10f581',
//         '#032c16'
//     ],
//     [
//         '#fedf3a',
//         '#372c1f'
//     ],
//     [
//         '#862828',
//         '#e9e9e9'
//     ],
//     [
//         '#ffffff',
//         '#C0C0C0'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#d38e1a',
//         '#3b755b',
//         '#000000',
//         '#ece7d4'
//     ],
//     [
//         '#0368bd',
//         '#c2332d',
//         '#0f0f0f',
//         '#ecddbe',
//     ],
//     [
//         '#e54f25',
//         '#017c88',
//         '#040202',
//         '#f1ddc2',
//     ],
//     [
//         '#5691ae',
//         '#f39e1a',
//         '#f0572f',
//         '#2b2728',
//         '#d2cbbe',
//     ],
//     [
//         '#87a4bf',
//         '#86aa9b',
//         '#1d1d1d',
//         '#fbf4ec',
//     ],
//     [
//         '#fd9a58',
//         '#252324',
//         '#fdebdf',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#017c88',
//         '#030202',
//         '#f1ddc2',
//     ],
//     [
//         '#f6f6f4',
//         '#ffffff',
//         '#3159ee',
//     ],
//     [
//         '#ff5937',
//         '#ff5937',
//         '#f6f6f4',
//     ],
//     [
//         '#ffc400',
//         '#009452',
//         '#252724',
//         '#fefefe',
//     ],
//     [
//         '#5d9d88',
//         '#ebb43b',
//         '#efebda',
//     ],
//     [
//         '#ff4c48',
//         '#567bae',
//         '#004996',
//         '#fff8e7',
//     ],
//     [
//         '#042050',
//         '#f2f2f2',
//         '#80c0f0',
//     ],
//     [
//         '#0b1a0b',
//         '#dd7440',
//         '#1bdf84',
//     ],
//     [
//         '#568486',
//         '#aa3941',
//         '#506638',
//         '#d5a630',
//         '#302b2b',
//         '#f3f0df',
//     ],
//     [
//         '#f1594a',
//         '#14a160',
//         '#f5b50e',
//         '#885fa4',
//         '#2969de',
//         '#1a1a1a',
//         '#e2e6e8',
//     ],
//     [
//         '#f1594a',
//         '#14a160',
//         '#f5b50e',
//         '#2969de',
//         '#000000',
//     ],
//     [
//         '#dd7440',
//         '#1bdf84',
//         '#0b1a0b',
//     ],
// ]
// export default allColors

const allColors = [
    [
        "#040309",
        "#FFFFFF",
    ], 
    [
        "#FFFFFF",
        "#040309",
    ], 
    [
        "blue",
        "white",
    ], 

]
export default allColors